import { isValidElement } from "react";

export const extractTextFromChildren = (children, recursively = false) => {
  if (typeof children === "string" || typeof children === "number") {
    return children.toString();
  }

  if (Array.isArray(children)) {
    return children.map(extractTextFromChildren).join("");
  }

  if (recursively && isValidElement(children) && children.props?.children) {
    return extractTextFromChildren(children.props.children);
  }

  return "";
};
